import { FC } from "react";
import { Link, LinkProps } from "react-router";
import { TUser } from "../../../common/types/user";

interface Props extends Omit<LinkProps, 'to'> {
    user?: TUser;
    withArrow?: boolean;
    isAdmin?: boolean;
    isDealer?: boolean;
}

const UserLink: FC<Props> = ({ user, withArrow = false, isAdmin = false, isDealer = false, ...otherParams }) => {
    if (isAdmin || isDealer) {
        return (
            <Link
                {...otherParams}
                to={`/users/${user?.id}`}
            >
                {user?.displayName}{withArrow ? <span className="text-primary"> &gt;</span>: ''}
            </Link>
        );
    }

    return user?.displayName;
};

export default UserLink;
